// 官网使用原 PC 全局组件与插件，会员路由和启动流程保留在 main.js。
import Vue from 'vue'
import '@g/utils/str'
import Vuetify from 'vuetify'
import zhHans from '@/locale/vuetifyZhHans'
import '@g/assets/iconfont.css'
import '@g/assets/quill.snow.css'
import '@g/assets/global.css'
import KImg from '@g/components/KImg'
import BankImage from '@g/components/BankImage'
import EventBus from '@g/components/EventBus'
import DocEvent from '@g/components/DocEvent'
import '@/assets/common.css'
import Snackbar from '@/components/Snackbar/index.js'
import filters from '@g/filters'
import Confirm from '@/components/Confirm'
import Countdown from '@g/components/Countdown'
import SrIcon from '@g/components/SrIcon'
import OrderTransportLabel from '@g/components/OrderTransportLabel'
import Tooltips from '@g/components/Tooltips'
import CarrierIcon from '@g/components/CarrierIcon'
import Schedule from '@g/components/Schedule'
import ContentPre from '@g/components/ContentPre.vue'
import SvgIcon from '@g/site/SiteSvgIcon.vue'
import LoadingDown from '@g/components/LoadingDown.vue'
import WhsText from '@g/components/Text/WhsText'
import '@g/components/Text/install'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-tw'
import calc from 'calculatorjs'
import dayjs from 'dayjs'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import FullScreenLoading from '@g/components/FullScreenLoading.vue'
import Countup from '@g/components/Countup.vue'
import { reportEvent } from '@g/utils/aosAnalytics'

import '@/components'

Vue.prototype.$sleep = function (s) {
  return new Promise(resolve => {
    setTimeout(resolve, s)
  })
}
Vue.prototype.$openWeb = function (url) {
  window.open(url)
}
Vue.use(Vuetify)
Vue.prototype.$vuetify.lang.locales.zhHans = zhHans
Vue.prototype.$vuetify.lang.current = 'zhHans'

Vue.prototype.$calc = calc
Vue.prototype.$dayjs = dayjs
Vue.prototype.$rptEvt = reportEvent
Vue.component('SrIcon', SrIcon)
Vue.component('OrderTransportLabel', OrderTransportLabel)
Vue.component('Tooltips', Tooltips)
Vue.component('ContentPre', ContentPre)
Vue.component('SvgIcon', SvgIcon)
Vue.component('LoadingDown', LoadingDown)
Vue.component('WhsText', WhsText)
Vue.component('CarrierIcon', CarrierIcon)
Vue.component('Schedule', Schedule)
Vue.component('Countdown', Countdown)
Vue.component('KImg', KImg)
Vue.component('BankImage', BankImage)
Vue.component('EventBus', EventBus)
Vue.component('DocEvent', DocEvent)
Vue.component('DatePicker', DatePicker)
Vue.component('FullScreenLoading', FullScreenLoading)
Vue.component('Countup', Countup)
Vue.use(Viewer)
Vue.use(Snackbar, {
  mode: 'vertical',
  y: 'top'
})

Vue.use(Confirm, {
  buttonTrueText: '確定',
  buttonFalseText: '取消',
  width: 300,
  property: '$confirm'
})

filters(Vue)
Vue.filter('toCurrency', function (value, sign = '¥', decimal = 2) {
  return isNaN(value)
    ? value
    : `${sign} ` + parseFloat(value).toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
})
Vue.filter('obfuscation', function (value) {
  if (!isNaN(value)) {
    return value.replace(/\d+(\d{4})$/g, '****$1')
  }
})
Vue.filter('nl2br', function (value) {
  return value ? value.replace(/[\n\r]/g, '<br>') : ''
})
Vue.filter('comma2br', function (value) {
  return value ? value.replace(/,/g, '<br>') : ''
})

window.countdownData = { currTime: Date.now() }
setInterval(() => { window.countdownData.currTime = Date.now() }, 1000)
